import {
  ButtonStyle,
  LinkButton,
  SideImageLayout,
} from '@versita/frontend/campus-ui-web';
import { useUserWidget } from '../../hooks/useUserWidget';
import notRegisteredImage from '../../assets/img/school_splash.jpg';

/**
 * A simple page that is shown to students who have not completed registration yet
 * when trying to access their timetable.
 */
export const NotRegisteredPage = () => {
  const userWidget = useUserWidget();
  return (
    <SideImageLayout
      userWidget={userWidget}
      heading={{
        title: 'You need to register',
        subtitle: 'My Timetable',
      }}
      image={notRegisteredImage}
    >
      <p>
        <big>
          It seems like you haven’t registered for this academic year. You need
          to complete registration before you can view your timetable.
        </big>
        <ul>
          <li>
            <strong>Returning students:</strong> visit{' '}
            <a href="https://www.salford.ac.uk/askus/topics/admin-essentials/registration">
              our registration webpage on the askUS website
            </a>
          </li>
          <li>
            <strong>New students:</strong> visit{' '}
            <a href="https://www.salford.ac.uk/welcome/registration">
              our registration webpage on the Welcome website
            </a>
          </li>
        </ul>
      </p>
      <h2>Already registered?</h2>
      <p>
        It will take a minimum of 72 hours after completing registration before
        your timetable is available. If you still can’t access your timetable
        after three days, contact our Timetabling team for help:
        <ul>
          <li>
            Email:{' '}
            <a href="mailto:timetable-enquiries@salford.ac.uk">
              timetable-enquiries@salford.ac.uk
            </a>
          </li>
          <li>
            Phone: <a href="tel:+44(0)1612950023">+44 (0)161 295 0023</a>{' '}
            (option 3)
          </li>
        </ul>
      </p>
      <p>
        Make sure to have your student ID number, course name and year of study
        ready when you contact us.
      </p>
      <h2>Viewing Course Timetables</h2>
      <p>
        If you know the name of your course you can view the public timetable
        for any course using the button below.
      </p>
      <LinkButton to="/courses" $buttonStyle={ButtonStyle.Secondary} $fullWidth>
        View All Timetables
      </LinkButton>
      <h3>What is a Course Timetable?</h3>
      <p>
        If you are a new student, your personal or group-level timetables are
        generally made available during your induction activities. You can find
        more information about your timetable on{' '}
        <a
          href="https://www.salford.ac.uk/askus/topics/admin-essentials/timetable-guidance"
          target="_blank"
          rel="noreferrer"
        >
          our timetable guidance webpage
        </a>
        .
      </p>
    </SideImageLayout>
  );
};

export default NotRegisteredPage;
